import styled from '@emotion/styled';

export const Label = styled.span`
	width: 150px;
	min-width: 150px;
	margin: auto 0;
	display: inline-block;
	font-size: 13px;
`;
